<template>

    <section class="c-settings_p1_integration">
        <h3>Integracja z Systemem P1</h3>
        <form @submit.prevent="validateForm('update-p1-integration-form')" data-vv-scope="update-p1-integration-form">

            <form-desc>Status integracji:
                <span class="c-settings_p1_integration__connection_status">
                    <strong v-if="integrationStatus === 'not_configured'" class="not_connected">Nie skonfigurowano</strong>
                    <strong v-if="integrationStatus === 'configuration_in_progress'" class="not_connected">W trakcie konfiguracji</strong>
                    <strong v-if="integrationStatus === 'configured_not_active'" class="not_connected">Skonfigurowana ale nieaktywna</strong>
                    <strong v-if="integrationStatus === 'active'" class="connected">Aktywna</strong>
                    <strong v-if="integrationStatus === 'error'" class="error">Wystąpił problem</strong>
                    <strong v-if="integrationStatus === 'unknown'" class="not_connected">Nieznany</strong>
                </span>
            </form-desc>

            <div class="c-settings_p1_integration__connection_error_details" v-if="connectionErrorDetails">{{ connectionErrorDetails }}</div>

            <form-desc>Prześlij pliki certyfikatów otrzymane z Centrum Certyfikacji Systemu P1. W celu uzyskania certyfikatów nalezy przejść <a href="https://www.cez.gov.pl/fileadmin/user_upload/proces_certyfikacji_podmiotu_w_systemie_p1_5bb729b453d58.pdf" target="_blank">proces certyfikacji</a> podmiotu w Systemie P1.</form-desc>

            <form-label>Certyfikat TLS:</form-label>
            <settings-p1-integration-cert-upload
                :existing-file="tlsCertExistingFile"
                v-model="tlsCertFile"
                v-validate="tlsCertExistingFile === null ? 'required' : ''"
                data-vv-as="certyfikat TLS">
            </settings-p1-integration-cert-upload>
            <form-input
                v-model="tlsCertPassword"
                placeholder="Hasło do certyfikatu TLS"
                type="password"
                data-vv-as="hasło do certyfikatu TLS"
                v-validate="'required'">
            </form-input>

            <br>

            <form-label>Certyfikat WSS:</form-label>
            <settings-p1-integration-cert-upload
                :existing-file="wssCertExistingFile"
                v-model="wssCertFile"
                v-validate="wssCertExistingFile === null ? 'required' : ''"
                data-vv-as="certyfikat TLS">
            </settings-p1-integration-cert-upload>
            <form-input
                v-model="wssCertPassword"
                placeholder="Hasło do certyfikatu WSS"
                type="password"
                data-vv-as="hasło do certyfikatu WSS"
                v-validate="'required'">
            </form-input>

            <br>

            <form-input
                v-model="oidNode"
                label="Identyfikator OID nadany przez P1"
                placeholder="2.16.840.1.113883.3.4424.2.7.X"
                type="text"
                data-vv-as="identyfikator OID nadany przez P1"
                v-validate="'required'">
            </form-input>

            <div v-if="this.entityType">

                <br>

                <div class="entity-type">Typ podmiotu: <strong>{{ entityType === 'practice' ? 'Praktyka fizjoterapeutyczna' : 'Podmiot leczniczy' }}</strong></div>

                <br>

                <div v-if="this.entityType !== 'practice'">
                    <form-desc>
                        Uzupełnij identyfikator Miejsca Udzielenia Świadczeń, o którym mowa w przepisach wydanych na podstawie art. 105 ust. 5 ustawy z dnia 15 kwietnia 2011 r. o działalności leczniczej:
                        <ul>
                            <li>
                                - w przypadku <strong>jednostki organizacyjnej</strong> podaj <strong>część V</strong> resortowego kodu identyfikacyjnego
                            </li>
                            <li>
                                - w przypadku <strong>komórki organizacyjnej</strong> podaj <strong>część VII</strong> resortowego kodu identyfikacyjnego
                            </li>
                        </ul>
                    </form-desc>
                    <form-radio-group label="Rodzaj identyfikatora Miejsca Udzielenia Świadczeń">
                        <form-radio
                            name="locationIdentifierType"
                            v-model="locationIdentifierType"
                            nativeValue="unit" v-validate="'required'">
                            Jednostka organizacyjna
                        </form-radio>
                        <form-radio
                            name="locationIdentifierType"
                            v-model="locationIdentifierType"
                            nativeValue="cell" v-validate="'required'">
                            Komórka organizacyjna
                        </form-radio>
                    </form-radio-group>
                </div>

                <form-input
                    v-model="locationIdentifierValue"
                    :label="locationIdentifierValueLabel"
                    placeholder=""
                    type="text"
                    :data-vv-as="locationIdentifierValueLabel"
                    v-validate="'required'">
                </form-input>

                <br>

                <form-switch
                    v-if="entityType"
                    label="Włącz integrację z P1"
                    v-model="integrationEnabled">
                </form-switch>

            </div>

            <div class="button-row">
                <v-btn
                    type="green"
                    role="submit"
                    has-loader
                    :loading="isLoading">
                    {{ entityType ? 'Zapisz' : 'Dalej'}}
                </v-btn>
                <form-desc v-if="entityType === null">Przejdź dalej aby uzupełnić dane Miejsca Udzielania Świadczeń.</form-desc>
            </div>
        </form>
    </section>

</template>


<script>

import {FormRow, FormSwitch, FormLabel, FormDesc, FormUpload, FormInput, FormRadioGroup, FormRadio} from 'Components/Form'
import SettingsP1IntegrationCertUpload from 'Components/Settings/SettingsP1IntegrationCertUpload'
import VBtn from 'Components/VBtn'
import {mapGetters} from 'vuex'

export default {

    name: 'SettingsP1Integration',

    data() {
        return {
            isLoading: false,
            integrationStatus: 'not_configured', // 'configuration_in_progress', 'configured_not_active', 'active', 'error', 'unknown'
            connectionStatus: 'not_connected', // 'not_connected', 'connected', 'error'
            connectionErrorDetails: null,
            tlsCertExistingFile: null,
            tlsCertFile: null,
            tlsCertPassword: null,
            wssCertExistingFile: null,
            wssCertFile: null,
            wssCertPassword: null,
            oidNode: null,
            entityType: null,
            locationIdentifierType: null,
            locationIdentifierValue: null,
            integrationEnabled: false,
            uploadProgress: 0
        }

    },

    computed: {
        ...mapGetters(['pht']),

        locationIdentifierValueLabel: function() {
            switch (this.locationIdentifierType) {
                case 'unit':
                    return 'Identyfikator jednostki organizacyjnej';
                case 'cell':
                    return 'Identyfikator komórki organizacyjnej';
                default:
                    return '3-cyfrowy identyfikator Miejsca Udzielania Świadczeń (domyślnie 001)';
            }
        }
    },

    mounted() {
        this.updateDataFromStore();
    },

    methods: {
        updateDataFromStore() {
            this.connectionStatus = this.pht.p1_integration_settings.connection_status;
            this.connectionErrorDetails = this.pht.p1_integration_settings.connection_error_details;
            this.tlsCertExistingFile = this.pht.p1_integration_settings.tls_cert_exists ? 'Certyfikat TLS dodany' : null;
            this.tlsCertFile = null;
            this.tlsCertPassword = this.pht.p1_integration_settings.tls_cert_password;
            this.wssCertExistingFile = this.pht.p1_integration_settings.wss_cert_exists ? 'Certyfikat WSS dodany' : null;
            this.wssCertFile = null;
            this.wssCertPassword = this.pht.p1_integration_settings.wss_cert_password;
            this.oidNode = this.pht.p1_integration_settings.oid_node;
            this.entityType = this.pht.p1_integration_settings.entity_type;
            this.locationIdentifierType = this.pht.p1_integration_settings.location_identifier_type;
            this.locationIdentifierValue = this.pht.p1_integration_settings.location_identifier_value;
            this.integrationEnabled = !!this.pht.p1_integration_settings.integration_enabled;

            if (this.connectionStatus === 'not_connected') {
                this.integrationStatus = 'not_configured';
            } else if (this.connectionStatus === 'connected' && this.entityType === null || this.locationIdentifierType === null || this.locationIdentifierValue === null) {
                this.integrationStatus = 'configuration_in_progress';
            } else if (this.connectionStatus === 'connected' && this.entityType && this.locationIdentifierType && this.locationIdentifierValue && !this.integrationEnabled) {
                this.integrationStatus = 'configured_not_active';
            } else if (this.connectionStatus === 'connected' && this.entityType && this.locationIdentifierType && this.locationIdentifierValue && this.integrationEnabled) {
                this.integrationStatus = 'active';
            } else if (this.connectionStatus === 'error') {
                this.integrationStatus = 'error';
            } else {
                this.integrationStatus = 'unknown';
            }
        },
        validateForm(scope) {
            this.isLoading = true
            this.$validator.validateAll(scope).then((isValid) => {
                if (isValid) {
                    this.updateP1Integration()
                } else {
                    this.isLoading = false
                    this.$alert.error('Integracja z Systemem P1', 'Popraw błędy w formularzu')
                }
            })
        },
        updateP1Integration() {
            this.isLoading = true
            let formData = new FormData();
            formData.append('tls_cert_file', (this.tlsCertFile === null ? '' : this.tlsCertFile));
            formData.append('tls_cert_password', this.tlsCertPassword);
            formData.append('wss_cert_file', (this.wssCertFile === null ? '' : this.wssCertFile));
            formData.append('wss_cert_password', this.wssCertPassword);
            formData.append('oid_node', this.oidNode);
            formData.append('location_identifier_type', (this.locationIdentifierType === null ? '' : this.locationIdentifierType));
            formData.append('location_identifier_value', (this.locationIdentifierValue === null ? '' : this.locationIdentifierValue));
            formData.append('integration_enabled', (this.integrationEnabled ? 1 : 0).toString());
            this.$store.dispatch('PHT_P1_INTEGRATION_UPDATE', formData).then((result) => {
                this.isLoading = false
                this.updateDataFromStore();
                this.$alert.success('Integracja z Systemem P1', 'Ustawienia integracji z systemem P1 zostały zaktualizowane')
            }).catch((error) => {
                this.isLoading = false
                this.$alert.error('Integracja z Systemem P1', error.response.data.message)
            })
        }
    },

    components: {
        FormRow,
        FormSwitch,
        FormLabel,
        FormDesc,
        FormUpload,
        VBtn,
        FormInput,
        FormRadioGroup,
        FormRadio,
        SettingsP1IntegrationCertUpload
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-settings_p1_integration {

    &__connection_status {
        .not_connected {
            color: inherit;
        }
        .connected {
            color: #42B983FF;
        }
        .error {
            color: #FF6666FF;
        }
    }

    &__connection_error_details {
        padding: 10px;
        background: #FF6666FF;
        color: white;
        margin-bottom: 1.4rem;
    }

    .entity-type {
        margin-bottom: 1rem;
    }

    .button-row {
        margin-top: 2rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row-reverse;

        .c-form_desc {
            margin: 0;
        }
    }
}

</style>
